import { createBrowserRouter, RouterProvider } from 'react-router-dom-v6'
import { QueryClientProvider } from '@tanstack/react-query'
import { createQueryClient } from '@clouway/query'
// sonner's Toaster directly, themed via prop from our own ThemeProvider
// (shadcn Vite pattern). The @clouway/ui wrapper hard-depends on next-themes,
// which dual-loads react under the Bazel vitest sandbox.
import { Toaster } from 'sonner'
// Import auth via the @/ alias (not a relative path) so it resolves to the
// SAME module id as every other `@/features/auth` importer. A relative
// './features/auth' resolves to a distinct id under the production rollup
// build, duplicating SessionProvider.tsx and its createContext — so a consumer
// importing via @/ (e.g. UserMenu) reads a second, empty SessionContext and
// sees user=null (avatar/menu silently absent in prod, fine in dev-serve).
import { SessionProvider } from '@/features/auth'
import { ThemeProvider, useTheme } from './components/ThemeProvider'
import { routes } from './routes'

const router = createBrowserRouter(routes)
const queryClient = createQueryClient()

function ThemedToaster() {
  const { theme } = useTheme()
  return <Toaster theme={theme} />
}

function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </QueryClientProvider>
      <ThemedToaster />
    </ThemeProvider>
  )
}

export default App
